(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
(function () {
  function syncSpacer(spacer, fixed) {
    if (!spacer || !fixed) return;
    spacer.style.height = fixed.offsetHeight + 'px';
  }

  function bindHeaderAutoHide(fixed) {
    if (!fixed || fixed.getAttribute('data-header-scroll-bound') === 'true') return;
    fixed.setAttribute('data-header-scroll-bound', 'true');

    var spacer = fixed.previousElementSibling;
    if (!spacer || !spacer.classList || !spacer.classList.contains('js-site-header-spacer')) {
      spacer = document.querySelector('.js-site-header-spacer');
    }

    var hiddenClass = 'site-header-fixed--hidden';
    var threshold = 64;
    var lastY = window.scrollY || window.pageYOffset || 0;

    function onScroll() {
      var y = window.scrollY || window.pageYOffset || 0;
      if (y < threshold) {
        fixed.classList.remove(hiddenClass);
      } else if (y > lastY) {
        fixed.classList.add(hiddenClass);
      } else {
        fixed.classList.remove(hiddenClass);
      }
      lastY = y;
    }

    function onResize() {
      syncSpacer(spacer, fixed);
    }

    syncSpacer(spacer, fixed);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize);

    document.addEventListener('shopify:section:load', function (ev) {
      if (ev.target && ev.target.contains && ev.target.contains(fixed)) {
        syncSpacer(spacer, fixed);
        lastY = window.scrollY || window.pageYOffset || 0;
        onScroll();
      }
      if (ev.target && ev.target.querySelector) {
        var headerSection = ev.target.querySelector('[data-section-type="header"]');
        if (headerSection) {
          bindHeaderSearch(headerSection);
        }
      }
    });
  }

  function bindHeaderSearch(section) {
    if (!section || section.getAttribute('data-header-search-bound') === 'true') return;
    section.setAttribute('data-header-search-bound', 'true');

    var sectionId = section.getAttribute('data-section-id');
    if (!sectionId) return;

    var panel = document.getElementById('CustomSearchOverlay-' + sectionId);
    if (!panel) return;

    var triggers = section.querySelectorAll('.js-custom-search-trigger');
    var closeButtons = panel.querySelectorAll('.js-custom-search-close');
    var input = panel.querySelector('.js-custom-search-input');
    var openClass = 'is-open';
    var bodyClass = 'custom-search-open';

    function openSearch() {
      panel.style.display = '';
      panel.setAttribute('aria-hidden', 'false');
      panel.classList.add(openClass);
      document.body.classList.add(bodyClass);
      triggers.forEach(function (trigger) {
        trigger.setAttribute('aria-expanded', 'true');
      });
      if (input) {
        window.setTimeout(function () {
          input.focus();
        }, 50);
      }
    }

    function closeSearch() {
      panel.classList.remove(openClass);
      panel.style.display = 'none';
      panel.setAttribute('aria-hidden', 'true');
      document.body.classList.remove(bodyClass);
      triggers.forEach(function (trigger) {
        trigger.setAttribute('aria-expanded', 'false');
      });
    }

    closeSearch();

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (panel.classList.contains(openClass)) {
          closeSearch();
        } else {
          openSearch();
        }
      });
    });

    closeButtons.forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        closeSearch();
      });
    });

    panel.addEventListener('click', function (event) {
      if (event.target === panel) {
        closeSearch();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && panel.classList.contains(openClass)) {
        closeSearch();
      }
    });
  }

  function initAll() {
    document.querySelectorAll('.js-site-header-fixed').forEach(function (el) {
      bindHeaderAutoHide(el);
    });
    document.querySelectorAll('[data-section-type="header"]').forEach(function (el) {
      bindHeaderSearch(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Read product id from data attribute
  var productId = productRecommendationsSection.dataset.productId;
  // Read limit from data attribute
  var limit = productRecommendationsSection.dataset.limit;
  // Build request URL
  var requestUrl = productRecommendationsSection.dataset.url + "?section_id=product-recommendations&limit=" + limit + "&product_id=" + productId;
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", requestUrl);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      var productRecommendationsParent = productRecommendationsSection.parentElement;
      productRecommendationsParent.innerHTML = container.querySelector(".product-recommendations").innerHTML;
      $(window).off('.productRecommendations');
      theme.initProductTitleAlignmentWatcher(productRecommendationsParent, '.productRecommendations');
    }
  };
  request.send();
};
// Reload the section in the editor when a setting changes
document.addEventListener("shopify:section:load", function(event) {
  if (event.detail.sectionId === "product-recommendations") {
    loadProductRecommendationsIntoSection();
  }
});
document.addEventListener("shopify:section:unload", function(event) {
  if (event.detail.sectionId === "product-recommendations") {
    $(window).off('.productRecommendations');
  }
});
// Fetching the recommendations on page load
document.addEventListener("DOMContentLoaded", function(event) {
  loadProductRecommendationsIntoSection();
});

  } catch(e) { console.error(e); }
})();
})();
